import { dateDayWeeksBefore } from 'utils/dates';

const dataPeerInvest = [
  {
    peer: 'Uber',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    peer: 'Lyft',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },

  {
    peer: 'GetAround',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },

  {
    peer: 'Scoop',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },

  {
    peer: 'Gett',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },

  {
    peer: 'GetAround',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    peer: 'Gett',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },

  {
    peer: 'Uber',
    investorType: 'SWF',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },

  {
    peer: 'Uber',
    investorType: 'Mutual Fund',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    peer: 'Scoop',
    investorType: 'Mutual Fund',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },

  {
    peer: 'Lyft',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    peer: 'Via',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },

  {
    peer: 'Uber',
    investorType: 'Mutual Fund',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },

  {
    peer: 'Uber',
    investorType: 'Mutual Fund',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    peer: 'Lyft',
    investorType: 'Mutual Fund',
    count: 2,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    peer: 'Scoop',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    peer: 'Blablacar',
    investorType: 'Venture Capital',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    peer: 'Grab',
    investorType: 'Venture Capital',
    count: 2,
    date: dateDayWeeksBefore(1, 5)
  },

  {
    peer: 'Uber',
    investorType: 'Pension Fund',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  }
];

export default dataPeerInvest;
